import { getCompareProducts } from '../storage/compare-storage';
import CartDrawer from '../../islands/cart-drawer';

export function initAddToCartListener() {
  document.addEventListener('click', async (e) => {
    const target = e.target as HTMLElement;
    const btn = target.closest('[data-add-to-cart]');
    if (!btn) return;

    const form = btn.closest('form') as HTMLFormElement | null;
    if (!form) return;

    const formData = new FormData(form);
    const productCard = btn.closest('[data-main-card-id]') as HTMLElement | null;

    if (productCard) {
      const productId = productCard.getAttribute('data-main-card-id');
      const products = getCompareProducts();
      const product = products.find((p) => p.id === productId);

      if (product?.currentVariantId) {
        formData.set('id', product.currentVariantId);
      }
    }

    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });

      const parsedState = await res.json();

      if (parsedState.status) {
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer') as CartDrawer | null;
      if (cartDrawer) {
        cartDrawer.renderContents(parsedState);
      }

      toggleComparePanelAfterAdd();
    } catch (_e) {
      /* empty */
    }
  });
}

function toggleComparePanelAfterAdd() {
  const mini = document.getElementById('compare-panel-minimized');
  const full = document.getElementById('compare-panel-full');

  if (mini && full) {
    mini.classList.remove('hidden');
    full.classList.add('hidden');
  }
}
